import React, { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";

const benefits = [
  "Learn any course you like",
  "No need to get ready as classes will be held online",
  "Enhance your resume with these courses",
  "Instructor led live classes",
  "24/7 hours support",
  "Courses are provided at affordable costs",
  "Availability of variety of courses",
  "Learning environment can be customized",
  "Schedule your classes at any time of the day",
];

const NeedCourses = () => {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Message sent! We'll contact you soon.`);
    // Here you can integrate EmailJS, Formspree or any email backend.
  };

  return (
    <section className="px-6 sm:px-10 lg:px-24">
      <div className="max-w-6xl mx-auto text-center mb-14">
        <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-800 mb-4">
          🎯 Need Any Courses?
        </h2>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          You will get various benefits by joining our courses. Here is a list of some of the benefits.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto mb-16">
        <ul className="space-y-5 text-left">
          {benefits.map((benefit, idx) => (
            <li key={idx} className="flex items-start gap-3 text-lg text-gray-700">
              <FaCheckCircle className="text-green-500 mt-1" />
              {benefit}
            </li>
          ))}
        </ul>

        <div className="bg-white p-8 rounded-2xl shadow-2xl border border-gray-200">
          <h3 className="text-2xl font-bold text-blue-600 mb-6">🚀 Enroll Now</h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
            <input
              type="tel"
              name="number"
              value={formData.number}
              onChange={handleChange}
              placeholder="Your Phone Number"
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your Email"
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Message"
              rows="4"
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
            <button
              type="submit"
              className="w-full bg-blue-600 text-white font-semibold py-3 rounded-xl hover:bg-blue-700 transition"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default NeedCourses;
